export default "__VITE_ASSET__f2ca2ed8__"